<div class="modal-wrapper">
  <div class="modal-header">
    <h4 *ngIf="!isBulkAccept" class="modal-title" id="modal-basic-title">Bulk Reject</h4>
    <h4 *ngIf="isBulkAccept" class="modal-title">Bulk Accept</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body eliminationMatrixDisplay fixed-body">
    <div class="row mt-4">
      <div class="col-12">
        <div *ngIf="predictionSectionVisible">
          <div class="select-type-selection-header" *ngIf="!showMixedPredictionsWarningMsg() && !comparablesWithNoPredictionsOnlyMsg()">
            <p>Please indicate your decision for the AI recommendation.</p>
          </div>
          <div class="select-type-selection-header" *ngIf="showMixedPredictionsWarningMsg()">
            <p>
              One or more of the selected companies have a different AI recommendation. The decision indicated below will be used for all selected
              comparable items.
            </p>
          </div>
          <div class="select-type-selection-header" *ngIf="showNaPredictionInBatchMessageMsgForAccept()">
            <p>
              Note: At least one company selected for the bulk accept does not have a trade description. The AI recommendation and user feedback to AI
              will not be applied to that company.
            </p>
          </div>
          <div class="select-type-selection-header" *ngIf="showNaPredictionInBatchMessageMsgForReject()">
            <p>
              Note: At least one company selected for the bulk reject does not have a trade description. The AI recommendation and user feedback to AI
              will not be applied to that company.
            </p>
          </div>
          <div class="select-type-selection-header" *ngIf="comparablesWithNoPredictionsOnlyMsg()">
            <p>Please indicate rejection reason for selected companies with missing business description.</p>
          </div>
          <div class="select-type-selection-header" *ngIf="!comparablesWithNoPredictionsOnlyMsg()"></div>
        </div>
      </div>

      <div class="col-12 select-type-selection-body mb-1 mt-4 section">
        <div class="col-12 select-type-selection-header mb-1">
          <span>Decision Criteria</span>
        </div>

        <div class="col-6 mb-4 ey-add-filter-body bulk-decision-criteria">
          <p-table [value]="selectedCols" [(selection)]="selectedCols" [scrollable]="true">
            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              <tr [pSelectableRow]="rowData">
                <td>
                  <div class="bdr-bulk-accept-reject-dialog-round">
                    <input
                      value="false"
                      [(ngModel)]="rowData.isSelected"
                      #column="ngModel"
                      type="checkbox"
                      id="column_{{ index }}"
                      name="column_{{ index }}"
                      (ngModelChange)="saveEliminationCriteria(rowData)"
                      [title]="rowData.isSelected ? '' : 'Please click to reject'"
                    />
                    <label for="column_{{ index }}"></label>
                  </div>
                  <div class="decision-criteria-value text">
                    <span>{{ rowData.name }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="col-12 select-type-selection-header mb-1">
          <span>Reason</span>
        </div>
        <div class="col-12">
          <div class="form-group">
            <span class="ey-float-label ey-textarea-label" title="Enter a reason">
              <textarea
                appAutosize
                class="form-control"
                id="reason"
                name="reason"
                (focusout)="showValidationMessage = false"
                [(ngModel)]="reason"
                maxlength="1000"
                minRows="2"
                minHeight="48"
                paddingHeight="32"
                appLabelFloat
              ></textarea>
              <label for="reason">Reason</label>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="showValidationMessage" class="validationMessage">
      <span class="help-block">
        {{ validationMessage }}
      </span>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>
